import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// no-dd-sa:javascript-code-style/parameter-name
export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
        location={location}
        navigate={navigate}
        params={params}
        history={{ push: navigate, replace: (path) => navigate(path, { replace: true }), goBack: () => navigate(-1) }}
        match={{ params }}
      />
    );
  }

  return ComponentWithRouterProp;
}
